<!-- @format -->

@if (wizardProgressSteps) {
  <app-cart-wizard-container [wizardStepKeys]="wizardProgressSteps" [currentStep]="currentStep">
    @if (loaded) {
      <div class="row">
        @if (cart?.items?.length > 0) {
          <div class="col-12 col-lg-10">
            <app-cart-wizard-step-heading
              tabindex="-1"
              [wizardStepKeys]="wizardProgressSteps"
              [currentWizardStepIndex]="currentStep"
              #currentStepTitle />
            <app-cart-check-selections
              [hidden]="currentStep !== STEP.CHECK_SELECTIONS"
              [cart]="cart"
              [checkEnrolments$]="checkEnrolments$"
              (hasValidEnrolments)="proceedToContactInformation()"
              (paymentTypeChange)="paymentType = $event"></app-cart-check-selections>
            <app-cart-contact-information
              [hidden]="currentStep !== STEP.CONTACT_INFORMATION"
              [cart]="cart"
              [submitClicked]="submitClickedSubject.asObservable()"
              (formSubmitted)="continueToPaymentSystem($event)"
              [autoConfirmText]="showAutoConfrimWizard"
              [paymentType]="paymentType"></app-cart-contact-information>
          </div>
          <div class="col-12 col-lg-10 wizard-step-button-container">
            <sis-wizard-step-buttons
              [backButtonTitle]="backButtonTitle | translate"
              [backButtonDisabled]="false"
              [backButtonDisplay]="true"
              [forwardButtonTitle]="forwardButtonTitle | translate"
              [forwardButtonDisabled]="requestInProgress"
              [forwardButtonDisabledTooltip]="'OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.WAITING_GUIDANCE' | translate"
              [forwardButtonDisplay]="true"
              (back)="back()"
              (forward)="forward()">
            </sis-wizard-step-buttons>
          </div>
        } @else {
          <div class="col-12 col-lg-10">
            <app-empty-cart />
          </div>
        }
      </div>
    }
    @if (!loaded) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">{{ "OPEN_UNIVERSITY_CART.WIZARD.LOADING" | translate }}</span>
      </div>
    }
  </app-cart-wizard-container>
}
